import type { Platform } from '@mint-lib/routing-context';
import { typographyVariants } from '@mint-lib/tw-components';

import { PlatformChip } from './PlatformChip.jsx';

type Props = {
  platforms: Platform[];
  title: string;
  ariaLabel: string;
};

const PlatformSection = ({ platforms, title, ariaLabel }: Props) => {
  if (!platforms.length) return null;

  return (
    <div className="flex flex-col gap-2" aria-label={ariaLabel}>
      <p className={typographyVariants({ variant: 'overline1' })}>{title}</p>
      <div className="flex flex-row flex-wrap gap-4">
        {platforms.map((platform) => (
          <PlatformChip
            key={platform.id}
            logo={platform.logo}
            label={platform.label}
          />
        ))}
      </div>
    </div>
  );
};

export { PlatformSection };
